export default __webpack_public_path__ + "static/media/confetti.e025050d.gif";